export default class RangeFilterConverter {

    /** @type {number} */
    _maxValue

    constructor(maxValue) {
        this._maxValue = maxValue
        this.prepareForQuery = this.prepareForQuery.bind(this)
    }

    /**
     * Increases the high end by 1 if it's the maximum.
     * @param {[number, number]} range Range filter value
     * @returns {[number, number]}
     */
    prepareForQuery(range) {
        if (range[1] < this._maxValue) return range
        return [range[0], this._maxValue + 1]
    }

}
